import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  JobseekerModerationAttributeEnum,
  RejectModel,
} from '../../shared/models/jobseeker-moderation.model';

@Component({
  selector: 'app-jobseeker-moderation-work-experience',
  templateUrl: './jobseeker-moderation-work-experience.component.html',
  styleUrls: ['./jobseeker-moderation-work-experience.component.less'],
  standalone: false,
})
export class JobseekerModerationWorkExperienceComponent {
  @Input() workExperience: any;
  @Input() isCreate: boolean;
  @Input() isEdited: boolean;
  @Input() changes: any;
  @Input() isWorkExperienceFilled!: boolean;
  @Input() totalWorkExperienceInMonths!: number;
  @Output() setDictionary: EventEmitter<RejectModel> =
    new EventEmitter<RejectModel>();

  public jobseekerEnum: any;

  constructor() {
    this.jobseekerEnum = JobseekerModerationAttributeEnum;
  }

  reject(event) {
    this.setDictionary.emit({ key: event.key, value: event.value });
  }

  checkAddedAndModifiedExperience(experienceId: string) {
    return (
      this.changes.jobseekerWorkExperienceChanges?.addedWorkExperiences?.some(
        (val) => val.experienceId === experienceId
      ) ||
      this.changes.jobseekerWorkExperienceChanges?.changedWorkExperiences?.some(
        (val) => val.experienceId === experienceId
      )
    );
  }
}
